import React from 'react';
import { trackEvent } from '../utils/metaPixel';
export function ContactSection() {
  const handleEmailClick = () => {
    trackEvent('Contact', {
      content_name: 'Email',
      content_category: 'contact'
    });
  };
  const handleInstagramClick = () => {
    trackEvent('Contact', {
      content_name: 'Instagram',
      content_category: 'contact'
    });
  };
  return <section className="py-16 px-4 bg-white" data-id="element-41">
      <div className="max-w-3xl mx-auto text-center" data-id="element-42">
        <h2 className="text-3xl font-bold text-teal-500 mb-6 font-baloo" data-id="element-43">
          📩 CONTÁCTANOS
        </h2>
        <p className="text-lg text-gray-600 mb-8" data-id="element-44">
          ¿Tienes alguna duda antes de comprar? ¿Necesitas ayuda con tu
          descarga?
          <br data-id="element-45" />
          <strong data-id="element-46">Estamos aquí para ti. Escríbenos:</strong>
        </p>

        <div className="flex flex-col md:flex-row justify-center gap-6 mb-8" data-id="element-47">
          <a href="mailto:mundoinfantildigital10@gmail.com" onClick={handleEmailClick} className="bg-teal-50 hover:bg-teal-100 border-2 border-teal-200 rounded-2xl p-6 flex items-center justify-center gap-4 transition-colors" data-id="element-48">
            <span className="text-3xl" data-id="element-49">📧</span>
            <div className="text-left" data-id="element-50">
              <p className="text-sm text-gray-500 font-bold uppercase" data-id="element-51">Email</p>
              <p className="text-teal-700 font-medium" data-id="element-52">
                mundoinfantildigital10@gmail.com
              </p>
            </div>
          </a>

          <a href="https://instagram.com/mundodecodigital" target="_blank" rel="noopener noreferrer" onClick={handleInstagramClick} className="bg-pink-50 hover:bg-pink-100 border-2 border-pink-200 rounded-2xl p-6 flex items-center justify-center gap-4 transition-colors" data-id="element-53">
            <span className="text-3xl" data-id="element-54">📸</span>
            <div className="text-left" data-id="element-55">
              <p className="text-sm text-gray-500 font-bold uppercase" data-id="element-56">
                Instagram
              </p>
              <p className="text-magenta font-medium" data-id="element-57">@mundodecodigital</p>
            </div>
          </a>
        </div>

        <p className="text-sm text-gray-500 italic bg-gray-50 inline-block px-6 py-2 rounded-full border border-gray-200" data-id="element-58">
          ⏰ Respondemos en menos de 24 horas. ¡No te quedes con ninguna duda!
        </p>
      </div>
    </section>;
}